import { useState } from "react"
import CustomButton from "../CustomButton"
import CustomFilters from "../CustomFilters"
import CustomInput from "../CustomInput"
import useToggle from "../../Hooks/useToggle"
import "./style.css"

const Header = ({ title = "", buttons, nofilters, search = "", onSearch, options }) => {

    const [isFilterOpen, _, toggleFilters] = useToggle(false)
    const hasHeaderFilters = (options?.length || 0) > 0

    return (
        <>
            <div className="pageToolbar">
                <div className="pageToolbarContent">
                    <div className="pageToolbarHeading">
                        <h2 className="mainTitle">{title}</h2>
                    </div>
                    <div className="pageToolbarActions">
                        {
                            !nofilters && hasHeaderFilters &&
                            <CustomButton text={isFilterOpen ? "Hide Filters" : "Filters"} className="pageToolbarButton" variant={isFilterOpen ? "primaryButton" : "secondaryButton"} onClick={toggleFilters} />
                        }
                        {
                            buttons?.map(item => (
                                <CustomButton text={item?.label} className="pageToolbarButton" onClick={item?.onClick} variant={item?.variant} />
                            ))
                        }
                        {
                            onSearch &&
                            <div className="pageToolbarSearch">
                                <CustomInput type="text" placeholder="Search anything..." value={search} inputClass="mainInput" onChange={onSearch} />
                            </div>
                        }
                    </div>
                </div>
            </div>
            {
                hasHeaderFilters && (
                    <CustomFilters
                        isFilterOpen={isFilterOpen}
                        dropdowns={options}
                    />
                )
            }
        </>
    )
}

export default Header
